const link = "https://www.lefisc.com.br/api/retFonte/api"
const token = "1551094d-975e-4fec-8c6a-c37946a23717"

module.exports  = {link,token} 
